import React from "react";
import arrowBtn from "Assets/icons/arrow_left.svg";
import notFoundBg from "Assets/images/loginImg.png";
import "./NotFound.scss";
import { NavLink } from "react-router-dom";
const NotFound = () => {
  return (
    <div className="notFound">
      <div className="notFound-container">
        <div className="content">
          <div className="error-container">
            <h1 className="title">Error 404</h1>
            <p className="subtitle">Página no encontrada</p>
            <p className="text">
              No pudimos encontrar la página que estás buscando. Te recomendamos
              volver al inicio para continuar navegando.
            </p>
          </div>
          <NavLink to="/">
            <button className="button" aria-label="Ir al inicio">
              <img src={arrowBtn} width={24} height={24} alt="arrow rigth" />
              Ir a la página de Inicio
            </button>
          </NavLink>
        </div>
      </div>
      <div className="error_img">
        <img src={notFoundBg} width={1920} height={1080} alt="background" />
      </div>
    </div>
  );
};

export default NotFound;
